import { Directive, inject, input } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Directive({
  selector: 'button[uiCloseDialog], i[uiCloseDialog]',
  standalone: true,
  host: {
    '(click)': 'onClick()',
  },
})
export class CloseDialogDirective {
  private readonly dialogRef = inject(DynamicDialogRef);

  public readonly data = input<unknown>(undefined, {
    alias: 'uiCloseDialog',
  });

  public onClick(): void {
    this.dialogRef.close(this.data());
  }
}
